import AutosaveSuccess from "@mui/icons-material/CheckCircle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Divider } from "@mui/material";
import { get } from "lodash";
import { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import comments_operations from "../comments/ducks/operations";
import searchOperations from "../search/ducks/operations";
import utils from "../utils";
import CompanyForm from "./CompanyForm";
import CompanyToolbar from "./CompanyToolbar";
import operations from "./ducks/operations";

const CompanyContainer = (props) => {
    const { getCompany, clearCompany } = props;
    const [parentCompanyTypeFilter, setParentCompanyTypeFilter] = useState(["BUSINESS"]);
    const params = useParams();

    useEffect(() => {
        const id = params.id;
        id ? getCompany(id) : clearCompany();

        ReactGA.send({ hitType: "pageview", page: "/company/*", title: `Company Admin: ${id}` });
    }, []);

    const handleChangeParentCompanyType = (value) => {
        setParentCompanyTypeFilter(value.split());
    };

    return (
        <div>
            <CompanyToolbar {...props} />

            <div style={{ display: "flex" }}>
                <div style={{ width: "50%" }}>
                    <Accordion defaultExpanded>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <AutosaveSuccess className="waterloo" /> Company Information
                        </AccordionSummary>
                        <Divider />
                        <AccordionDetails>
                            <CompanyForm
                                {...props}
                                parentCompanyTypeFilter={parentCompanyTypeFilter}
                                handleChangeParentCompanyType={(value) => handleChangeParentCompanyType(value)}
                            />
                        </AccordionDetails>
                    </Accordion>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        userProfile: state.authReducer.userProfile,
        companyType: get(state.adminReducer, "company.companyType", null),
        company: get(state.adminReducer, "company", null),
        autocompleteResults: get(state.searchReducer, "autocompleteResults", null),
        errors: state.utilsReducer.errors ? state.utilsReducer.errors : {},
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleSubmit: (save, callback) => {
            dispatch(utils.operations.toggleConfirm());
            dispatch(operations.handleSubmitPropertyForm(save, callback));
        },
        handleInputChange: (field, value) => {
            dispatch(operations.handleInputChange(field, value));
        },

        toggleSnackBar: (open, variant, message) => {
            dispatch(utils.operations.snackbar(open, variant, message));
        },
        toggleConfirm: (onSubmit) => {
            dispatch(utils.operations.toggleConfirm(onSubmit));
        },
        handleDocumentWarning: (open, proceed, docs) => {
            dispatch(operations.handleDocumentWarning(open, proceed, docs));
        },
        handleConfirmWarning: () => {
            dispatch(operations.handleDocumentWarning(false, true, []));
        },
        toggleComments: () => {
            dispatch(comments_operations.toggleComments());
        },
        handleAddArrayElement: (arrayPath) => {
            dispatch(operations.addArrayElement(arrayPath));
        },
        handleDeleteArrayElement: (arrayPath, index) => {
            dispatch(operations.deleteArrayElement(arrayPath, index));
        },
        handleUpdateArrayElement: (arrayPath, index, field, value) => {
            dispatch(operations.handleInputChange(arrayPath + "[" + index + "]." + field, value));
        },
        clearPropertyState: () => {
            dispatch(operations.clearPropertyDetailState());
        },
        handleChooseDisplayDeleteDialog: (isOpen, propertyKey) => {
            dispatch(operations.displayDeleteDialog(isOpen, propertyKey));
        },
        deleteCompany: (companyKey) => {
            return dispatch(operations.deleteCompany(companyKey));
        },
        saveCompany: () => {
            dispatch(operations.saveCompany());
        },
        saveCompanyAndExit: () => {
            return dispatch(operations.saveCompanyAndExit());
        },
        getCompany: (id) => {
            dispatch(operations.getCompany(id));
        },
        clearCompany: () => {
            dispatch(operations.clearCompany());
        },
        handleSearchParentCompany: (term, type) => {
            dispatch(searchOperations.searchParentCompany(term, type));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyContainer);
